<app-home-privacy-terms-header
  [header]="header"
></app-home-privacy-terms-header>
<app-home-privacy-terms-body
  [contentTranslocoKey]="'home.privacy.content'"
></app-home-privacy-terms-body>
